import "../style/style.scss";

import { Tooltip } from 'bootstrap';

import $ from 'jquery';
import ClipboardJS from 'clipboard';

window.jQuery = $;
window.$ = $;

// using jQuery
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

window.getCookie = getCookie;

const csrftoken = getCookie('csrftoken');

$(document).ready(function(){
    $("[data-bs-toggle='tooltip']").each(function() {
        new Tooltip($(this));
    });
    let clipboard = new ClipboardJS('.share-link');
    clipboard.on('success', function(e) {
        console.log(e);
    });

    clipboard.on('error', function(e) {
        console.log(e);
    });
});

$(document).ready(function() {
    $('a[href*="simplex"]').hide();
    $('a[href*="#"]:not([href="#"])').click(function() {
        var offset = -120;
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html, body').stop(true, false).animate({
                    scrollTop: target.offset().top + offset
                }, 1000);
                return false;
            }
        }
    });
});


$(document).ready(function() {
    let scroll_position = 'top';
    let logo_container = $('div.logo-200');
    function setMobiLogo() {
        let pos = $(document).scrollTop();
        if(pos > 100 && scroll_position === 'top') {
            scroll_position = 'bottom';
            logo_container.addClass('scrolled');
        } else if(pos <= 100 && scroll_position === 'bottom') {
            scroll_position = 'top';
            logo_container.removeClass('scrolled');
        }
    }
    $(window).scroll(function () {
        setMobiLogo();
    });
    setMobiLogo();
});

function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

$.ajaxSetup({
    beforeSend: function(xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
            xhr.setRequestHeader("X-CSRFToken", csrftoken);
        }
    }
});


function favoriteRoute(route_id) {
    let url = '/api/favorite/route/';
    fetch(url, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "X-CSRFToken": getCookie("csrftoken"),
        },
        body: JSON.stringify({'route_id': route_id})
    })
        .then((res) => {
            if(res.status !== 200) {
                console.log("Es ist ein Fehler augetreten");
            }
            return res.json();
        })
        .then(json => {
            // Highlight or de-highlight the heart
            if(json.result === 1) {
                $('a[data-link-type="favorite-route"][data-route-id="' + route_id + '"]').addClass('active');
            } else {
                let target_link = $('a[data-link-type="favorite-route"][data-route-id="' + route_id + '"]');
                target_link.removeClass('active');
                // Check if the item needs to be removed (if in favorites)
                if(target_link.data('remove')) {
                    $('.tooltip').remove();
                    target_link.closest('.card').parent().remove();
                }
            }
        })
        .catch(err => {
            console.log(err);
        });
}

function favoriteActivity(activity_id) {
    let url = '/api/favorite/activity/';
    fetch(url, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "X-CSRFToken": getCookie("csrftoken"),
        },
        body: JSON.stringify({'activity_id': activity_id})
    })
        .then((res) => {
            if(res.status !== 200) {
                console.log("Es ist ein Fehler augetreten");
            }
            return res.json();
        })
        .then(json => {
            // Highlight or de-highlight the heart
            if(json.result === 1) {
                $('a[data-link-type="favorite-activity"][data-activity-id="' + activity_id + '"]').addClass('active');
            } else {
                let target_link = $('a[data-link-type="favorite-activity"][data-activity-id="' + activity_id + '"]');
                target_link.removeClass('active');
                // Check if the item needs to be removed (if in favorites)
                if(target_link.data('remove')) {
                    $('.tooltip').remove();
                    target_link.closest('.card').parent().remove();
                }
            }
        })
        .catch(err => {
            console.log(err);
        });
}


$(document).ready(function() {
    $('a[data-link-type="favorite-route"]').click(function () {
        favoriteRoute($(this).data('route-id'));
        return false;
    });
    $('a[data-link-type="favorite-activity"]').click(function () {
        favoriteActivity($(this).data('activity-id'));
        return false;
    });
});
